import type { FC } from 'react';

import { formatFinancialMetric, FundamentalValuationsType } from '@/utilities';

import { FinancialValue } from './FinancialValue';

interface FinancialMetricValueProps {
    type?: FundamentalValuationsType;
    value: number;
}

export const FinancialMetricValue: FC<FinancialMetricValueProps> = ({ type, value }) => {
    if (type === FundamentalValuationsType.PERCENT || type === FundamentalValuationsType.RATIO) {
        return <>{formatFinancialMetric(value, type)}</>;
    }

    return <FinancialValue kind={type === FundamentalValuationsType.NUMBER ? 'number' : 'currency'} value={value} />;
};
